export default "__VITE_ASSET__D73onsG8__"